// extracted by mini-css-extract-plugin
export var missionBoxShadow = "missionStyles-module--mission-box-shadow--sOXTn";